import * as React from "react";
import brandedSpinner from '../../../resources/images/brandedSpinner.png';
import styles from './ProcessSpinner.module.scss';

export interface ProcessSpinnerProps {
    showText?: boolean;
}

const loadingSteps = ['Reading Playlist', 'Converting Songs', 'Processing', 'Finish Processing'];

export const ProcessSpinner: React.FC<ProcessSpinnerProps> = ({showText}) => {
    const [text, setText] = React.useState(loadingSteps[0]);
    const [counter, setCounter] = React.useState(0);

    React.useEffect(() => {
        const interval = setInterval(() => {
            if (counter < 3) {
                setText(loadingSteps[0]);
            } else if (counter < 6) {
                setText(loadingSteps[1]);
            } else if (counter < 9) {
                setText(loadingSteps[2]);
            } else {
                setText(loadingSteps[3]);
            }
            setCounter(prev => prev + 1)
        }, 1000);
        return () => clearInterval(interval);
    },[counter]);

    return (
        <div className={styles.spinner__container}>
                <div className={styles.spinner__icon}>
                    <img src={brandedSpinner} alt="Loading"/>
                </div>
            {showText && <div className={styles.spinner__text}>{text}</div>}
        </div>
    );
}
